import Image1 from "../assets/winner_1.png"
import Image2 from "../assets/winner_2.png"
import Image3 from "../assets/winner_3.png"
export const Dataofcard = [
    {
        img:Image1,
        position:`<h4>Winner</h4>`,
        award:"Cash Prize- Rs 2,000/-, Certificate and Memento.",
    },
    {
        img:Image2,
        position:`<h4>1 st Runner Up</h4>`,
        award:"Cash Prize- Rs 1,500/- and Certificate.",
    },
    {
        img:Image3,
        position:`<h4>2 nd Runner Up</h4>`,
        award:"Cash Prize- Rs 1,000/- and Certificate.",
    },
];